(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play-context/assets/javascripts/actions.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play-context/assets/javascripts/actions.js');
"use strict";


const actionTypes = {
  SET_RACE: 'SET_RACE',
  UPDATE_CURRENT_RACE: 'UPDATE_CURRENT_RACE',
  UPDATE_CURRENT_WINODDS: 'UPDATE_CURRENT_WINODDS',
  UPDATE_CURRENT_SHOWODDS: 'UPDATE_CURRENT_SHOWODDS',
  UPDATE_CURRENT_DISTRIBUTION: 'UPDATE_CURRENT_DISTRIBUTION',
  UPDATE_CURRENT_IO_DISTRIBUTION: 'UPDATE_CURRENT_IO_DISTRIBUTION'
};
const actions = {
  setRace: race => ({
    type: actionTypes.SET_RACE,
    race
  }),
  updateRace: race => ({
    type: actionTypes.UPDATE_CURRENT_RACE,
    race
  }),
  updateWinodds: winodds => ({
    type: actionTypes.UPDATE_CURRENT_WINODDS,
    winodds
  }),
  updateShowodds: showodds => ({
    type: actionTypes.UPDATE_CURRENT_SHOWODDS,
    showodds
  }),
  updateDistribution: distribution => ({
    type: actionTypes.UPDATE_CURRENT_DISTRIBUTION,
    distribution
  }),
  updateIoDistribution: ioDistribution => ({
    type: actionTypes.UPDATE_CURRENT_IO_DISTRIBUTION,
    ioDistribution
  })
};
svs.racing_game.components.playContext.actions = actions;
svs.racing_game.components.playContext.actionTypes = actionTypes;

 })(window);